import { Flex, Switch, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { Form } from "@/organisms/Form"
import { CardTemplate } from "@/pages/GovernancePage/components/pages/AiPolicyPage/components/CardTemplate"

import type { LiveEnforcementSectionProps } from "./LiveEnforcementSection.types"

// Block or only record what the rules match; the access types are a rule.
// A shown policy reads as the form does, the switch read-only
export const LiveEnforcementSection = ({
  policy
}: LiveEnforcementSectionProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.ai.live.form"
  })
  const { form } = Form.useForm()
  const watched = Form.useWatch("enforce", form)
  const enforce = policy ? policy.action === "BLOCK" : watched
  const label = t("uponViolation.enforce")

  return (
    <Flex vertical gap={14}>
      <Text type="secondary">{t("uponViolation.description")}</Text>
      <CardTemplate type="notAllow">
        <Flex vertical gap={4} flex={1}>
          <Flex gap={10} align="center">
            {policy ? (
              <Switch
                size="small"
                aria-label={label}
                checked={enforce}
                disabled
              />
            ) : (
              <Form.Item noStyle name="enforce" valuePropName="checked">
                <Switch size="small" aria-label={label} />
              </Form.Item>
            )}
            <Text>{label}</Text>
          </Flex>
          <Text type="secondary" className="sm-text-ks">
            {t(
              enforce
                ? "uponViolation.enforceOnHelp"
                : "uponViolation.enforceHelp"
            )}
          </Text>
        </Flex>
      </CardTemplate>
    </Flex>
  )
}
